import React from "react";

function TermsAndConditions() {
  return <div>TermsAndConditions</div>;
}

export default TermsAndConditions;
